import { api } from 'helpers'
import axios from 'axios'

export interface CheckRemovalResponse {
  can_remove: boolean
  has_assessments: boolean
  affected_students_count: number
  activity_count: number
  message: string
}

export interface RemoveItemResponse {
  message: string
  removed_activity_lv4_items_count: number
  removed_final_assessment_scores_count: number
  removed_project_lv4_item: boolean
}

interface ApiErrorData {
  error?: string
  errors?: string
  message?: string
}

function isAxiosError(error: unknown): error is { response?: { data?: ApiErrorData }; message?: string } {
  return axios.isAxiosError(error)
}

export function extractErrorMessage(error: unknown, fallback: string): string {
  if (!isAxiosError(error)) {
    return error instanceof Error ? error.message : fallback
  }
  return (
    error.response?.data?.error ??
    error.response?.data?.errors ??
    error.response?.data?.message ??
    error.message ??
    fallback
  )
}

export async function checkItemRemoval(
  projectId: string,
  lv4ItemId: string
): Promise<CheckRemovalResponse> {
  if (!projectId || !lv4ItemId) {
    throw new Error('projectId and lv4ItemId are required')
  }
  const response = await api.post<CheckRemovalResponse>(
    `/api/arc_mosaico/projects/${projectId}/check_item_removal`,
    { lv4_item_id: lv4ItemId }
  )
  return response.data
}

export async function removeProjectItem(
  projectId: string,
  lv4ItemId: string
): Promise<RemoveItemResponse> {
  if (!projectId || !lv4ItemId) {
    throw new Error('projectId and lv4ItemId are required')
  }
  const response = await api.delete<RemoveItemResponse>(
    `/api/arc_mosaico/projects/${projectId}/remove_item`,
    { data: { lv4_item_id: lv4ItemId, confirmed: true } }
  )
  return response.data
}
